// src/discussions/components/LikeButton.tsx
import { FaHeart } from "react-icons/fa";
import { FiHeart } from "react-icons/fi";
import { useAuth } from "wasp/client/auth";
import { useAction } from "wasp/client/operations";
import {
  toggleDiscussionLike,
  toggleCommentLike,
} from "wasp/client/operations";
import { Button } from "../../components/common";
import { cn } from "../../client/cn";

interface LikeButtonProps {
  discussionId?: number;
  commentId?: number;
  isLiked: boolean;
  likesCount: number;
  size?: "sm" | "md" | "lg";
  className?: string;
}

export function LikeButton({
  discussionId,
  commentId,
  isLiked,
  likesCount,
  size = "md",
  className = "",
}: LikeButtonProps) {
  const { data: user } = useAuth();
  const toggleDiscussionLikeFn = useAction(toggleDiscussionLike);
  const toggleCommentLikeFn = useAction(toggleCommentLike);

  const handleClick = async () => {
    if (discussionId) {
      await toggleDiscussionLikeFn({ discussionId });
    } else if (commentId) {
      await toggleCommentLikeFn({ commentId });
    }
  };

  const sizeClasses = {
    sm: "text-sm gap-1.5",
    md: "text-base gap-2",
    lg: "text-lg gap-2.5",
  } as const;

  return (
    <Button
      type="button"
      variant="ghost"
      tone={isLiked ? "primary" : "neutral"}
      size="xs"
      onClick={() => {
        void handleClick();
      }}
      className={cn(
        "flex items-center rounded-full px-0 py-0",
        sizeClasses[size],
        user ? "hover:text-primary" : "cursor-not-allowed opacity-50",
        className,
      )}
      disabled={!user}
      aria-pressed={isLiked}
    >
      {isLiked ? (
        <FaHeart className={size === "lg" ? "text-xl" : ""} />
      ) : (
        <FiHeart className={size === "lg" ? "text-xl" : ""} />
      )}
      <span>{likesCount}</span>
    </Button>
  );
}
